import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { ProgramTemplate } from '../Types/programTemplatesTypes';

export const programTemplatesApi = createGenericApiSlice<ProgramTemplate>({
  reducerPath: 'programTemplatesApi',
  tag: TagTypes.ProgramTemplate,
  endpoint: 'program-template',
});

export const {
  useGetAllQuery: useGetProgramTemplatesQuery,
  useGetByIdQuery: useGetProgramTemplateByIdQuery,
  useCreateMutation: useCreateProgramTemplateMutation,
  useUpdateMutation: useUpdateProgramTemplateMutation,
  useDeleteMutation: useDeleteProgramTemplateMutation,
} = programTemplatesApi;
